/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AccreditationCountry = {

	delete (context, id, onSuccess, onError, options) {
		Api.delete(context,
			"/accreditation-country"
			+ "?id=" + id
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, onSuccess, onError, options) {
		Api.get(context,
			"/accreditation-country"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getListAll (context, onSuccess, onError, options) {
		Api.get(context,
			"/accreditation-country/list-all"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, accreditationCountryDTO, onSuccess, onError, options) {
		Api.post(context,
			"/accreditation-country"
			, accreditationCountryDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, accreditationCountryDTO, onSuccess, onError, options) {
		Api.put(context,
			"/accreditation-country"
			, accreditationCountryDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
